import axios from 'axios';

/**
 * Token do parceiro exigido pelo backend (checatoken) em /api/recorrencia/*.
 * Vem do build: REACT_APP_TOKEN_API no .env. Se o build for feito sem a
 * variavel, TODA chamada de recorrencia volta 401 "O token fornecido nao foi
 * autorizado" (incidente de 11/09/2026: build de 08/09 sem .env). O
 * scripts/check-env.js (prebuild) impede o build sem a variavel; este aviso
 * cobre o caso de alguem buildar fora do npm.
 */
export const TOKEN_API: string | undefined = process.env.REACT_APP_TOKEN_API;

if (!TOKEN_API) {
  // eslint-disable-next-line no-console
  console.error('[apiPlay] REACT_APP_TOKEN_API ausente no build: chamadas de recorrencia vao falhar com 401.');
}

const apiPlay = axios.create({
  baseURL: 'https://sistema.playmovel.com.br',
});

// const apiPlay = axios.create({
//     baseURL: "https://dev.operadora.app.br"
// })

/**
 * Injeta o token em toda chamada de recorrencia que nao o tenha no corpo.
 * Cobre listaCartoes (Fatura) e statusrecorrencia (TelaRecorrencia), que
 * nunca mandaram token, e protege contra esquecimento em chamadas novas.
 */
apiPlay.interceptors.request.use((config) => {
  const url = config.url || '';
  if (!url.startsWith('/api/recorrencia/') || !TOKEN_API) {
    return config;
  }
  const data = config.data;
  if (data && typeof data === 'object' && !Array.isArray(data) && !('token' in data && data.token)) {
    config.data = { ...data, token: TOKEN_API };
  } else if (data === undefined || data === null) {
    config.data = { token: TOKEN_API };
  }
  return config;
});

export default apiPlay;
